import React, { useState } from 'react'
import styled from 'styled-components'
import { FiStar } from 'react-icons/fi'
import { FaStar } from 'react-icons/fa'
import { useFavorites } from 'src/hooks/users/useFavorites'

export const FavoritesToggle = ({ postId, size = 20 }) => {
  const { isFavorited, toggleFavorite } = useFavorites()
  const [message, setMessage] = useState(null)
  const [showMessage, setShowMessage] = useState(false)

  const handleClick = () => {
    const wasFavorited = isFavorited(postId)
    toggleFavorite(postId)
    setMessage(wasFavorited ? 'Unfavorited' : 'Favorited')
    setShowMessage(true)
    setTimeout(() => setShowMessage(false), 1000)
  }

  return (
    <div style={{ position: 'relative' }}>
      <div
        onClick={handleClick}
        className="cursor-pointer mr-2"
      >
        {isFavorited(postId) ? (
          <FaStar size={size} className="text-yellow-400 transition duration-300" />
        ) : (
          <FiStar size={size} className="text-neutral-600 hover:text-black transition duration-300" />
        )}
      </div>

      <Message $visible={showMessage}>{message}</Message>
    </div>
  )
}

const Message = styled.div`
  position: absolute;
  top: 30px;
  left: 50%;
  transform: translateX(-50%);
  background: black;
  color: white;
  font-size: 13px;
  padding: 6px 12px;
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);
  opacity: ${(props) => (props.$visible ? 1 : 0)};
  transition: opacity 0.3s ease;
  pointer-events: none;
  white-space: nowrap;
  z-index: 20;
`
